import HttpClient from '@/common/Http';
import { Litigation } from '@/Litigation/litigation.entity';

export default class LitigationService {
    private httpClient: HttpClient;

    constructor() {
        this.httpClient = new HttpClient('litigations');
    }

    private static normalize(litigation: Litigation): Litigation {
        const { members } = litigation;
        return {
            ...litigation,
            members: members ? (Array.isArray(members) ? members : Object.values(members)) : [],
        };
    }

    async find(litigationId: string): Promise<Litigation> {
        return LitigationService.normalize(await this.httpClient.get<Litigation>(`/litigations/${litigationId}`));
    }

    async findAll(): Promise<Litigation[]> {
        return (await this.httpClient.get<Litigation[]>('/litigations')).map(LitigationService.normalize);
    }

    public async create(name: string): Promise<Litigation> {
        return LitigationService.normalize(await this.httpClient.post<Litigation>('/litigations', { name }));
    }

    public update(litigationId: string, litigation: Litigation): Promise<Litigation> {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { criteria, ...litigationWithoutCriteria } = litigation;

        return this.httpClient.put<Litigation>(`/litigations/${litigationId}`, litigationWithoutCriteria);
    }
}
